var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from 'react';
import { MdAdd } from 'react-icons/md';
import { Button, TransparentButton, Icon, Text } from "../../..";
import { useToggle } from "../../../../hooks";
import { BulkAddModal } from './BulkAddModal';
export var BulkDialog = function (_a) {
    var id = _a.id, onAdd = _a.onAdd, _b = _a.label, label = _b === void 0 ? 'Add Bulk' : _b, _c = _a.isTransparent, isTransparent = _c === void 0 ? true : _c, _d = _a.buttonLss, buttonLss = _d === void 0 ? {} : _d, _e = _a.palette, palette = _e === void 0 ? 'primary' : _e, _f = _a.dialogTitle, dialogTitle = _f === void 0 ? 'Add Bulk Options' : _f, _g = _a.subTitle, subTitle = _g === void 0 ? 'Enter each option on a separate line.' : _g;
    var _h = __read(useToggle(false), 2), isOpen = _h[0], toggleModal = _h[1];
    var ButtonComponent = isTransparent ? TransparentButton : Button;
    return (React.createElement(React.Fragment, null,
        React.createElement(ButtonComponent, { id: id, type: "button", emphasis: "medium", palette: palette, lss: __assign({ p: 'sm', display: 'flex', alignItems: 'center' }, buttonLss), onClick: toggleModal },
            React.createElement(Icon, { as: MdAdd, size: 20, lss: { mr: 'sm', color: 'secondary500' } }),
            React.createElement(Text, { lss: { mr: 'lg', textScale: 'control' } }, label)),
        React.createElement(BulkAddModal, { isOpen: isOpen, onClose: toggleModal, onAdd: function (values) { return onAdd(values); }, dialogTitle: dialogTitle, subTitle: subTitle })));
};
//# sourceMappingURL=BulkAddButton.js.map